<template>
	<el-drawer size="35%" title="设置" :visible.sync="dialogVisible" direction="rtl" :modal-append-to-body="false" :wrapperClosable="false"
		class="customer-drawer-common set-skillgroup">
		<el-form ref="form" :model="form" :rules="formRules" label-width="120px">
			<el-form-item label="京东名称：" prop="appName">
				<el-input placeholder="请输入京东名称" v-model="form.appName" clearable disabled>
				</el-input>
			</el-form-item>
			<el-form-item label="京东APPID：" prop="appId">
				<el-input placeholder="请输入京东APPID" v-model="form.appId" clearable disabled>
				</el-input>
			</el-form-item>
			<el-form-item label="授权品牌：" prop="brand">
				 <el-select v-model="form.brand" clearable placeholder="请选择授权品牌" @change="onBrandChange">
				    <el-option
				      v-for="item in brand_options"
				      :key="item.id"
				      :label="item.name"
				      :value="item.id">
				    </el-option>
				  </el-select>
			</el-form-item>
			<el-form-item label="技能组：" prop="skillGroup" >
				<el-select v-model="form.skillGroup" clearable placeholder="请选择技能组" :loading="loading_skill">
				   <el-option
				     v-for="item in skillGroup_options"
				     :key="item.skillId"
				     :label="item.skillName"
				     :value="item.skillId">
				   </el-option>
				 </el-select>
			</el-form-item>
			
		</el-form>
		<div class="footer">
			<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
	</el-drawer>
</template>

<script>
	import {mapGetters} from 'vuex';
	export default {
		computed:{
			 ...mapGetters([
				'subBrandList'
			]),
		},
		data(){
			return {
				loading:false,
				loading_skill:false,
				dialogVisible:false,
				brand_options:[],
				skillGroup_options:[],
				form:{
					appName:'',
					appId:'',
					brand:'',
					skillGroup:''
				},
				formRules:{
					appName:[{ required: true, message: '请输入微博名称', trigger: 'blur' }],
					appId:[{ required: true, message: '请输入微博ID', trigger: 'blur' }],
					brand:[{ required: true, message: '请选择品牌', trigger: 'change' }],
					skillGroup:[{ required: true, message: '请选择技能组', trigger: 'change' }],
				}
			}
		},
		methods:{
			onSave(){
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true;
						this.$api.apiAcceptAuthForSystem(this.form.appId,{
							brand:this.form.brand,
							skillGroup:this.form.skillGroup,
							channel:'JDongminiprogram'
						}).then(res => {
							this.loading = false;
							if(res.errcode != 0) return;
							this.onSet(JSON.parse(res.data));
						})
					}
				})
			},
			onSet(data){
				this.$api.apiUpdateBindJdItem({
					app_id:this.form.appId,
					forward_url:data.imUrl
				}).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('操作成功');
					this.dialogVisible = false;
					this.$emit('getList')
				})
			},
			async openSeting(row){
				this.dialogVisible = true;
				this.loading = false;
				Object.keys(this.form).map(item => {
					this.form[item] = row[item];
				})
				if(!row.forwardUrl) return;
				await this.$api.apiGetAcceptAuthForSystem(row.appId).then(res => {
					if(res.errcode != 0) return;
					this.form.brand = res.data[0].childBrand;
					this.getSkillGroup({
						brand:res.data[0].childBrand,
						skillId:res.data[0].skillId,
					})
					
				})
			},
			getSkillGroup(data){
				let result = [];
				this.loading_skill = true;
				this.$api.getWechatSystemSkillGroup({brand:data.brand,appid:this.form.appId}).then(res => {
					this.skillGroup_options = res.data;
					this.form.skillGroup = data.skillId ? data.skillId : '';
					this.loading_skill = false;
				}).catch(err => {
					this.loading_skill = false;
				}) 
			},
			onBrandChange(val){
				if(val){
					this.getSkillGroup({
						brand:val,
					})
					return;
				}
				this.skillGroup_options = [];
				this.form.skillGroup = '';
			}
		},
		async mounted(){
			this.brand_options= await this.subBrandList;
		}
	}
</script>

<style lang="scss" scoped>
	.set-skillgroup {
		
	}
</style>
